import script from "./MessageItem.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageItem.vue?vue&type=script&setup=true&lang=js"

import "./MessageItem.vue?vue&type=style&index=0&id=662d9cbe&lang=scss"

const __exports__ = script;

export default __exports__